import { memo } from 'react';
import { IconWrapper } from './IconWrapper';

export const MarkInProgressIcon = memo(() => (
    <IconWrapper>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16">
            <path
                fill="currentColor"
                fillRule="evenodd"
                // eslint-disable-next-line max-len
                d="M3.05 3.05A7 7 0 0 1 8 1v14A7 7 0 0 1 3.05 3.05Zm8.832.38.643-.766a6.988 6.988 0 0 0-2.091-1.22l-.342.938a5.986 5.986 0 0 1 1.79 1.048ZM13.905 7l.984-.206a6.945 6.945 0 0 0-.819-2.271L13.204 5a6.26 6.26 0 0 1 .701 2Zm-3.471 7.556-.342-.938a5.987 5.987 0 0 0 1.79-1.048l.643.766a6.99 6.99 0 0 1-2.091 1.22ZM13.204 11l.866.5c.404-.711.68-1.487.82-2.294l-.985-.173a6.076 6.076 0 0 1-.7 1.967Z"
                clipRule="evenodd"
            />
        </svg>
    </IconWrapper>
));
